"use client";

import { createContext, useContext, useEffect, useState } from "react";
import { getToken, setToken } from "./api";

type AuthCtx = {
  token: string | null;
  signIn: (t: string) => void;
  signOut: () => void;
  ready: boolean;
};

const Ctx = createContext<AuthCtx>({
  token: null, signIn: () => {}, signOut: () => {}, ready: false,
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [token, setTok] = useState<string | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setTok(getToken());
    setReady(true);
  }, []);

  const signIn = (t: string) => { setToken(t); setTok(t); };
  const signOut = () => { setToken(null); setTok(null); };

  return (
    <Ctx.Provider value={{ token, signIn, signOut, ready }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
